import { Icon, Typography } from "@mui/material";
import { Container } from "@mui/system";
import CustomSection from "components/CustomSection";
import form_styles from "components/SpecificStyles/form.module.css";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { post } from "utilities/requests";
import { toast } from "react-toastify";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import CustomInput from "components/CustomInput";
import EmailIcon from '@mui/icons-material/Email';

const LoginPage = () => {
  let navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    let form = new FormData();
    form.append("email", email);
    form.append("password", password);

    const res = await post("auth/login", form);

    if (res?.status === true) {
      localStorage.setItem("token", res.access_token);
      localStorage.setItem("user", JSON.stringify(res.user));
      navigate("/admin/dashboard");
    } else {
      let showed = false;

      if (res?.errors?.password) {
        toast.error(res.errors.password[0]);
        showed = true;
      }
      if (res?.errors?.email) {
        toast.error(res.errors.email[0]);
        showed = true;
      }

      try {
        toast.error(res.errors[0]);
        showed = true;
      } catch {}


      if (!showed) toast.error("Erro ao fazer login. Consulte o Suporte.");
    }
  };

  return (
    <CustomSection
      style={{
        overflow: "hidden",
      }}
    >
      <Container
        maxWidth="xl"
        sx={{
          width: "100vw",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: "1rem",
        }}
      >
        <Typography
          variant="h2"
          sx={{
            textAlign: "center",
            fontWeight: 600,
          }}
        >
          Login
        </Typography>

        <Typography
          variant="p"
          sx={{
            fontSize: "1.1rem",
            textAlign: "center",
            margin: "0 auto",
            fontWeight: "normal",
            maxWidth: "30rem",
          }}
        >
          Faça login para continuar.
        </Typography>

        <form
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
            marginTop: "2rem",
            width: "100%",
            maxWidth: "30rem",
          }}
          className={form_styles.customFormStyle}
          onSubmit={handleSubmit}
        >
          <CustomInput
            type="email"
            placeholder="E-mail"
            icon={EmailIcon}
            value={email}
            onChange={setEmail}
            required
          />

          <CustomInput
            type={showPassword ? "text" : "password"}
            placeholder="Senha"
            icon={showPassword ? VisibilityOffIcon : VisibilityIcon}
            value={password}
            onChange={setPassword}
            required
            onClick={() => setShowPassword(!showPassword)}
          />
          

          {/* <div
            style={{
              position: "relative",
            }}
          >
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Senha"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <Icon
              sx={{
                position: "absolute",
                right: "1rem",
                top: "50%",
                transform: "translateY(-50%)",
                cursor: "pointer",
                opacity: 0.7,
                "&:hover": {
                  opacity: 1,
                },
              }}
              onClick={() => setShowPassword(!showPassword)}
              component={showPassword ? VisibilityOffIcon : VisibilityIcon}
            />
          </div> */}

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "1rem",
            }}
          >
            <Typography
              variant="p"
              sx={{
                fontSize: "1rem",
                // textAlign: "center",
                fontWeight: "normal",
              }}
            >
              Esqueceu a senha? <a href="#">Clique aqui</a>.
            </Typography>
            <input type="submit" style={{
              maxWidth: "12rem",
            }} />
          </div>
        </form>
      </Container>
    </CustomSection>
  );
};

export default LoginPage;
